let lastGlobalRequestErrorAt = 0;
let lastGlobalRequestErrorMessage = "";

/** 记录最近一次请求层错误，让页面兜底提示避免再次弹出重复的错误 Toast。 */
export const markGlobalRequestError = (message = "") => {
    lastGlobalRequestErrorAt = Date.now();
    lastGlobalRequestErrorMessage = message;
};

/** 判断页面错误是否紧随请求层错误产生，时间窗口覆盖同一请求事件的 React 更新周期。 */
export const hasRecentGlobalRequestError = (windowMs = 1500, expectedMessage?: string) => {
    if (lastGlobalRequestErrorAt <= 0 || Date.now() - lastGlobalRequestErrorAt > windowMs) return false;
    // 页面兜底 Alert 兼容旧调用可以只判断时间；请求 Toast 去重必须匹配同一条后端文案。
    return expectedMessage === undefined || lastGlobalRequestErrorMessage === expectedMessage;
};

/** 判断静态 message.error 是否紧随请求层错误产生，避免旧页面兜底提示重复展示。 */
export const shouldSuppressLocalRequestError = (windowMs = 300) => {
    if (lastGlobalRequestErrorAt <= 0 || Date.now() - lastGlobalRequestErrorAt > windowMs) return false;
    return true;
};
